'use strict';

import {recoveryModel} from "@js/models/recoverymodel";

export class ProjectRecoveryListCtrl
{
	recoveries = [];
	
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$timeout = $timeout;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.setRecoveries(this.jsDataService.get('recoveries', {}));
	}
	
	setRecoveries(recoveries){
		this.recoveries = [];
		for(let recoveryData of recoveries){
			this.recoveries.push(new recoveryModel(recoveryData, this.$filter, this.jsDataService));
		}
	}
	
	removeRecovery(ev, recovery){
		console.log(recovery.remove_url);
			const confirmTexts = this.jsDataService.get('recoveryRemoveTexts');
			console.log(confirmTexts);
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: recovery.remove_url,
					method: 'POST',
					params: {}
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
	}
	
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
}


